import { Modal, Space, Table, Tooltip, Input, Popconfirm, Select, Button } from "antd";
import React from "react";
import { withRouter } from "../../components/withRouter";
import Header from "../../components/Header";
import {
  CheckCircleTwoTone,
  CloseCircleTwoTone,
  DollarOutlined,
  EditOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import { openNotification } from "../../functions";
import TextArea from "antd/es/input/TextArea";

const { Option } = Select;

class Spheres extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modalRole: false,
      clientName: "",
      salesPoints: [],
      editPoint: false,
      pointModal: false,
      point_disc: "",
      point_name: "",
      point_type: 0,
      sum_ot: 0,
      procent: 0,
      desc_sphere: "",
      delete_balanse_bonus: 0,
      editPoint_id: 0,

      addBonusModal: false,
      addBonusPrice: 0,
      addBonusDesc: "",
      addBonusRole: 0,
    };
    this.customNavFunction = this.customNavFunction.bind(this);
  }

  onChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    this.setState({ [name]: value });
  };

  customNavFunction() {
    return this.props.navigate("/");
  }

  setRole(rec) {
    this.setState({
      modalRole: true,
      clientName: rec.name + "/" + rec.tgName,
    });
  }

  getPoints() {
    fetch(`https://bot.weddingchelny.ru/api/adm/spheres`, {
      headers: new Headers({
        "Content-Type": "application/json; charset=utf-8",
        Authorization: "Bearer " + localStorage.getItem("ttk"),
      }),
      method: "GET",
    }).then(async (response) => {
      if (response.status == 401) {
        localStorage.clear();
        this.customNavFunction();
      } else {
        let res = await response.json();
        if (res.error) {
          openNotification("Ошибка", res.error, 1, 3.0);
        } else {
          this.setState({ salesPoints: res.data, editPoint: false });
        }
      }
    });
  }

  ChangeInputValue = (e) => {
    let name = e.target.name;
    let value = e.target.type === "checkbox" ? e.target.checked : e.target.value;
    this.setState({ [name]: value, inputChanged: true });
  };

  savePoint() {
    if (this.state.point_name == "" || this.state.point_disc == "" || this.state.point_type == "") {
      return openNotification("Ошибка", "Все должны быть заполнены", 1, 3.0);
    }
    fetch(
      this.state.editPoint == true
        ? `https://bot.weddingchelny.ru/api/adm/spheres/` + this.state.editPoint_id
        : `https://bot.weddingchelny.ru/api/adm/spheres/`,
      {
        headers: new Headers({
          "Content-Type": "application/json; charset=utf-8",
          Authorization: "Bearer " + localStorage.getItem("ttk"),
        }),
        method: this.state.editPoint == true ? "PATCH" : "POST",
        body: JSON.stringify({
          name: this.state.point_name,
          discount: this.state.point_disc,
          type: this.state.point_type,
          sum_ot: this.state.sum_ot,
          procent: this.state.procent,
          delete_balanse_bonus: this.state.delete_balanse_bonus,
          desc_sphere: this.state.desc_sphere,
        }),
      }
    ).then(async (response) => {
      if (response.status == 401) {
        localStorage.clear();
        this.customNavFunction();
      } else {
        let res = await response.json();
        if (res.error) {
          openNotification("Ошибка", res.error, 1, 3.0);
        } else {
          this.setState({
            pointModal: false,
            point_name: "",
            point_disc: "",
            point_type: "",
            sum_ot: 0,
            procent: 0,
            delete_balanse_bonus: 0,
            desc_sphere: "",
          });
          this.getPoints();
        }
      }
    });
  }

  postBonuses() {
    fetch(`https://bot.weddingchelny.ru/api/adm/spheres/post/bonuses`, {
      headers: new Headers({
        "Content-Type": "application/json; charset=utf-8",
        Authorization: "Bearer " + localStorage.getItem("ttk"),
      }),
      method: "POST",
      body: JSON.stringify({
        addBonusPrice: this.state.addBonusPrice,
        addBonusDesc: this.state.addBonusDesc,
        addBonusRole: this.state.addBonusRole,
      }),
    }).then(async (response) => {
      if (response.status == 401) {
        localStorage.clear();
        this.customNavFunction();
      } else {
        let res = await response.json();
        if (res.error) {
          openNotification("Ошибка", res.error, 1, 3.0);
        } else {
          this.setState({
            addBonusModal: false,
            addBonusPrice: 0,
            addBonusDesc: "",
            addBonusRole: 0,
          });
          openNotification("Успешно", res.message, 3, 3.0);
        }
      }
    });
  }

  changeStatus(id, status) {
    fetch(`https://bot.weddingchelny.ru/api/adm/spheres/` + id + `/status`, {
      headers: new Headers({
        "Content-Type": "application/json; charset=utf-8",
        Authorization: "Bearer " + localStorage.getItem("ttk"),
      }),
      method: "PATCH",
      body: JSON.stringify({
        status: status,
      }),
    }).then(async (response) => {
      if (response.status == 401) {
        localStorage.clear();
        this.customNavFunction();
      } else {
        let res = await response.json();
        if (res.error) {
          openNotification("Ошибка", res.error, 1, 3.0);
        } else {
          this.getPoints();
        }
      }
    });
  }

  render() {
    const data = [
      {
        key: "1",
        name: "Точка 1",
        address: "улица Пушкина, дом Колотушкина",
        ban: 0,
      },
      {
        key: "2",
        name: "Точка на рынке",
        address: "улица Простая, дом 19",
        ban: 1,
      },
    ];

    // eslint-disable-next-line no-sparse-arrays
    const columns = [
      {
        title: "Название",
        dataIndex: "name",
        key: "name",
      },
      {
        title: "Скидка",
        dataIndex: "disc",
        key: "disc",
        render: (text, record) => {
          return (
            <div>
              {record.discount}
              {record.type == 1 ? "%" : "руб."}
            </div>
          );
        },
      },
      {
        title: "Сумма от которой действет скидка",
        dataIndex: "sum_ot",
        key: "sum_ot",
      },
      {
        title: "Процент с каждой покупки",
        dataIndex: "procent",
        key: "procent",
      },
      ,
      {
        title: "Сумма сгораемого бонуса при переходе на роль",
        dataIndex: "delete_balanse_bonus",
        key: "delete_balanse_bonus",
      },
      {
        title: "Действия",
        dataIndex: "events",
        key: "events",
        render: (text, record) => {
          return (
            <Space size="large">
              <Tooltip title="Изменить">
                <EditOutlined
                  onClick={() => {
                    this.setState({
                      editPoint: true,
                      point_name: record.name,
                      point_disc: record.discount,
                      pointModal: true,
                      desc_sphere: record.desc_sphere,
                      procent: record.procent,
                      delete_balanse_bonus: record.delete_balanse_bonus,
                      sum_ot: record.sum_ot,
                      point_type: record.type,
                      editPoint_id: record.id,
                    });
                  }}
                  style={{ cursor: "pointer" }}
                />
              </Tooltip>
              <Tooltip title="Добавить сгорающих бонусов всем владельцам роли">
                <DollarOutlined
                  onClick={() => {
                    this.setState({
                      addBonusModal: true,
                      addBonusPrice: 0,
                      addBonusDesc: "",
                      addBonusRole: record.id,
                    });
                  }}
                  style={{ cursor: "pointer" }}
                />
              </Tooltip>
              {/* {record.sp_status == 1 ? (
                <Popconfirm
                  title="Защита от случайного нажатия"
                  description="Вы действительно хотите отключить точку продаж?"
                  onConfirm={() => {
                    this.changeStatus(record.key, 0);
                  }}
                  onCancel={() => {}}
                  okText="Да"
                  cancelText="Нет"
                >
                  <Tooltip title="Точка активна">
                    <CheckCircleTwoTone twoToneColor="#52c41a" />
                  </Tooltip>
                </Popconfirm>
              ) : (
                <Popconfirm
                  title="Защита от случайного нажатия"
                  description="Вы действительно хотите включить точку продаж?"
                  onConfirm={() => {
                    this.changeStatus(record.key, 1);
                  }}
                  onCancel={() => {}}
                  okText="Да"
                  cancelText="Нет"
                >
                  <Tooltip title="Точка заблокирована">
                    <CloseCircleTwoTone twoToneColor="#eb2f96" />
                  </Tooltip>
                </Popconfirm>
              )} */}
            </Space>
          );
        },
      },
    ];

    return (
      <div>
        <Header />
        <div className="container">
          <Space>
            <h1>Сферы</h1>
            <Button
              onClick={() => {
                this.setState({ editPoint: false, point_name: "", point_disc: "", pointModal: true, editPoint_id: 0 });
              }}
              type="primary"
            >
              Добавить сферу
            </Button>
          </Space>
          <Table columns={columns} dataSource={this.state.salesPoints} />
          <Modal
            title={"Точка продаж"}
            open={this.state.pointModal}
            onOk={() => {
              this.savePoint(0);
            }}
            onCancel={() => {
              this.setState({ editPoint: false, point_name: "", point_disc: "", pointModal: false });
            }}
            okText="Сохранить"
            cancelText="Отмена"
          >
            <Space direction="vertical" style={{ width: "100%" }}>
              <div>
                <div>Название</div>
                <Input name="point_name" value={this.state.point_name} onChange={this.ChangeInputValue.bind(this)} />
              </div>
              <div>
                <div>Тип скидки</div>
                <input
                  type="radio"
                  id="option1"
                  name="choice"
                  onChange={(e) => {
                    this.setState({ point_type: Number(e.target.value) });
                  }}
                  checked={this.state.point_type === 1}
                  value="1"
                />
                <label for="option1">В процентах</label>
                <input
                  type="radio"
                  id="option2"
                  name="choice"
                  onChange={(e) => {
                    this.setState({ point_type: Number(e.target.value) });
                  }}
                  checked={this.state.point_type === 2}
                  value="2"
                />
                <label for="option2">В рублях</label>
              </div>
              <div>
                <div>Скидка</div>
                <Input name="point_disc" value={this.state.point_disc} onChange={this.ChangeInputValue.bind(this)} />
              </div>
              <div>
                <div>Сумма от которой действет скидка</div>
                <Input name="sum_ot" value={this.state.sum_ot} onChange={this.ChangeInputValue.bind(this)} />
              </div>
              <div>
                <div>Процент бонусов от каждой покупки</div>
                <Input name="procent" value={this.state.procent} onChange={this.ChangeInputValue.bind(this)} />
              </div>
              <div>
                <div>Описание</div>
                <TextArea
                  name="desc_sphere"
                  value={this.state.desc_sphere}
                  onChange={this.ChangeInputValue.bind(this)}
                />
              </div>

              <div>
                <div>Сумма сгораемого бонуса при переходе на роль</div>
                <Input
                  name="delete_balanse_bonus"
                  value={this.state.delete_balanse_bonus}
                  onChange={this.ChangeInputValue.bind(this)}
                />
              </div>
            </Space>
          </Modal>

          <Modal
            title={"Добавить сгорающих бонусов всем владельцам роли"}
            open={this.state.addBonusModal}
            onOk={() => {
              this.postBonuses();
            }}
            onCancel={() => {
              this.setState({ addBonusModal: false, addBonusPrice: 0, addBonusDesc: "", addBonusRole: 0 });
            }}
            okText="Сохранить"
            cancelText="Отмена"
          >
            <div>
              <div>Сумма начисляемых бонусов</div>
              <Input
                name="addBonusPrice"
                value={this.state.addBonusPrice}
                onChange={this.ChangeInputValue.bind(this)}
              />
            </div>
            <div>
              <div>Описание, которое получат владельцы роли</div>
              <TextArea
                name="addBonusDesc"
                value={this.state.addBonusDesc}
                onChange={this.ChangeInputValue.bind(this)}
              />
            </div>
          </Modal>
        </div>
      </div>
    );
  }

  componentDidMount() {
    this.getPoints();
  }
}

export default withRouter(Spheres);
